module.exports = __webpack_public_path__ + "img/equipos-de-sala-gal-3.84eba23d.png";